import {enumOf} from "@rezonence/enum-generator";
import {FreeWallEvent} from "./freewall.event";
import { keys } from "ts-transformer-keys";

export type FreewallEventColumn = keyof FreeWallEvent;

export const FreewallEventColumn = enumOf(keys<FreeWallEvent>());
